export default "__VITE_ASSET__b6f29091__"